import React from "react";

// The round-start roll call on the scoreboard (Score.tsx, round-intro.ts): on
// each player's beat in the countdown their row (or PC card, or chip) lights
// up: a wash and a sweep across the row, and a ring bursting from the flag.
// Every piece carries the player's beat as its animation delay.

type Fx = { style: React.CSSProperties; fx: string };

// Overlays that fill the row (inside it, under the body; a card's lean included).
export function RowIntroFx({ style, fx }: Fx) {
  return (
    <>
      <div className="score-bar-intro-wash" style={{ ...style, background: fx }} />
      <div className="score-bar-intro-sweep" style={{ ...style, background: `linear-gradient(90deg, rgba(0,0,0,0) 0%, ${fx} 55%, rgba(0,0,0,0) 100%)` }} />
    </>
  );
}

// The ring, centred on the flag (inside score-flag-wrap), upright even on a
// leaning card.
export function FlagIntroFx({ style, fx }: Fx) {
  return <span className="score-intro-ring" style={{ ...style, borderColor: fx }} />;
}
